<template>
  <v-container>
    <div class="mt-3">
      <iframe
        :src="url"
        frameborder="0"
        type="application/pdf"
        width="100%"
        height="800px"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import "jspdf-autotable";
import { jsPDF } from "jspdf";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "print-preview-sale-down-payment",
  props: {
    id: Number,
  },
  computed: {
    ...mapState("external", ["contacts"]),
    ...mapState("auth", ["userDetail"]),
    total() {
      let total = 0;
      this.saleDownPayment.products.forEach(x => {
        total += x.total;
      });
      return total;
    },
  },
  data() {
    return {
      saleDownPayment: {},
      url: "",
    };
  },
  methods: {
    async preview() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleDownPayment/getById", this.id)
        .then(async response => {
          this.saleDownPayment = response.data;
          await this.$store.dispatch("external/getContact", response.data.customerId);
          this.createPdf();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    contactName(id) {
      const contact = this.contacts.find(x => x.id === id);
      const name = contact ? contact.name : "";
      return name;
    },
    setNewArray(items) {
      const array = [];
      items.forEach((x, index) => {
        array.push([
          {
            content: index + 1,
            styles: { valign: "top", halign: "left" },
          },
          {
            content: x.partNumber,
            styles: { valign: "top", halign: "left" },
          },
          {
            content: x.mfr,
            styles: { valign: "top", halign: "left" },
          },
          {
            content:
              x.partDesc +
              " " +
              this.formatRemark(x.remark) +
              "\n\n\n\n\n\n" +
              this.formatBank(x.bank),
            styles: { valign: "top", halign: "left" },
          },
          {
            content: x.quantity + " " + x.unitMeasure,
            styles: { valign: "top", halign: "left" },
          },
          {
            content: this.formatPrice(x.unitPrice),
            styles: { valign: "top", halign: "right" },
          },
          {
            content: this.formatPrice(x.total),
            styles: { valign: "top", halign: "right" },
          },
        ]);
      });
      return array;
    },
    formatBank(bank) {
      if (bank) {
        let first = `ACCOUNT BANK :\n${bank.bankName}\nCABANG ${bank.branch},\n${bank.address}\nA/N : ${bank.ownerName}\n`;
        bank.items.forEach(x => {
          first = first + `NO : ${x.accountNumber}\n`;
        });
        let result =
          first + `SWIFT CODE : ${bank.swiftCode}\nPlease pay the full amount of this invoice`;
        return result;
      }
      return "";
    },
    formatRemark(remark) {
      if (remark) {
        return remark;
      }
      return "";
    },
    createPdf() {
      const doc = new jsPDF();
      const imgData =
        "iVBORw0KGgoAAAANSUhEUgAAASgAAAAeCAYAAAHoVLOLAAAsV0lEQVR4nO2dB5xVxfXHf++9+9o2dgUWUBRsWLGiGOwl0dhii8YSEzVGYzf612iiITEaY4nG3mI0Nuw9dmLDhoqiAkJAQKQvy/bd1+5/vrMecn1ZFKPGFIbP4713370zZ86cOed3zpyZDcJcKczHGxRLlBS01KlU3a5SmFEQS+vrKkEuiGnT4afow4Vrad1hCzR9fkZXnnOw9tpqPcVisa+HqDBf0LXX/0oT57Rp642r9MgrHykeT6myslJ//OMftccee2illVbS448/rvXWW0+ZTEZbbrmlKioqdNBBB6m6ulrHHnusJk6cqL322ksvvfSSRowYoa6uLrW1tekb3/iGdt55Z/34xz/WnDlz9P777/vvZ555po4++mj16dNHCxcu1FprraUzzjhDd999tyMqHmjarFb9aOTdmv/Sz3TBhZfqmosOU3t7+xLKm5qaPtGTsWPHfuI7xFFeeeWVT7z3dM+wYcPU0NDgP+fzeY0cOVIbbbSRNtxwQ82YMUM/+tGPFHQVWsOYKpUPQ+WCvNIFKZNIfm1DRwkOOOUaPTxmjiOkpKvPOlw/+eUlah57jRQGSyUsdB34KokOxrwxTVefto9O/P3jmtbYrFKpwl3udCzu0sorr6xXX31Vm2yyiZeHXXfdVY899piy2azWWWcdTZ482cve1KlTNX78eP3iF7/QG2+8oRNPPFG//e1vNWDAAM2bN09PP/20vvOd7+iEE07Qn/70Jx1++OF68skndeCBB2qnnXbSH/7wB3344Ye64IILvAwGYdipoy94VsoVdP0116gUr3JEJZ0AVqujo8NTXigU/HtUlmbOnOnfi8Wifx88eLD23HNP//mqq67y7yaXe++9t3+/4oor/MsKAp/L5bywf/DBB9piiy30yCOPKGgMW8Ohw8/SfnsNU7/V69Q6P6fLr39aa63dS3t9Z5jSxbTOu+Qm3XTp6dpj66FSLPmVDdu/cwmqCmkVq9u0wZCsDr9ojPbt06ZVB/bSby86RLvsf5lqCp269NzzFFeXSspp3pyFXsUgHsziUqnk1Frcy/4RRxyh6667zs8BvgdB91x55plndNttt+nyyy/3ai6RSPhRt7nC5+OPP96PLNesTgpaI5lM+vYQ8Z/97GdemhC/008/3bfDvTzHi7pQkbTNvfzW0tLiJYp6//rXv2rbbbf1v0+bNk1rrLHGElqsbep8/fXX1atXL6255pq+/SAfLFaxPdQ6QzbQTw/qrYN3WEObHnK+tqzro6uP3ldTWgo6/Owbde+lBzppKmrRokV+HjLPmAbo+QMOOMBfQ2QnTZqkdDqt888/3xN88803+9+YW4jyoYce6m3AT3/6Uy/mEESH+/btq3333VejRo3SD3/4Q5199tm67LLLdO211/p6N9hgAx111FHeLnCNub799tsvsQ1MjxtvvNGr5WeffVbNzc2eFpgKs2HauHHj/GDCjPfee0/HHHOM/zx69Gjtv//+nvm0W1VVpd13390zCKZxPYh1Vuu1Ry9TdaFNJ31/RacWS5r77HlqC9Pae99tnBS16MRDtlevTEHxUtYbP5gTLffee+8/iCrKyMr3v/99/6JAbLRsvfXW3lhGy1133eXfkU4KjMdIUq6//nr/fuedd37iGXSR6SNKXV2dV6hLKzAehiLdMOuBBx5Y0jbM6ezs9MoYaTvttNMUFDqawpKDTUFXjXJpZyTDKsUcQgiUV7N7sLa0QIsLfVQbL6iUqFT86zOHX2sJ9jnxMr03fpYOPnEPBxPiuv3PL2vK3MU6+fjtVZPO6LXnx2jQesN04TG7ymke98j/JqeCoNRfY188QvXbXKdkU6AKN/U6e8e07ipr6LEn3tNDYxt09PqVjkVx0MoSRb2soOWrBjj/qhLki52aNKtL9YWJaqgZoDlPnKLhB16jK27+o16eFGrsLb/VqCcekkqBirGCTj75ZM2fP1+33HLLkvmNwoxaOrNaXEPho4RXWWUVnXPOOUuYZtbFvlMnegV9xDXq5HfauPLKKzV79myPkVdbbTWv8L/73e92d8C1Z/fSJvXyDAahtrZWxx13nAYOHOjr5To0oNjRT9ttt92S9nkWfWQ04ZhMmTJFF154of8tSKaqNX92m0449Teq6x/XDidcoHRltX647z7asSPQ6HGvqZit95VhPX73u9/poYce8p4HBcu02WabeeQ4a9Ys7+FgvSCYDtLwxhtv7O/n+5FHHuktInVgzUC0WCis4tprr+0RLF4R1uvXv/61/44DkkqlvBXDy/nb3/7m0S8Fz+eFF17wlm/TTTf1Jh0Levvtt+snP/mJf27BggXee8I6r7766p5BwJGXX35Z06dP90YAa8p1aMVwzJ0717eDBwc0cRK1QH1qapwPOk6pukFatbKk8U6V1xUDhflWHX3xAzrmyN29ako7nbX7brt6Juywww7eKgDPIQLrBZoFxmO6GU1GAkIx3ViRaxzKPumkk7wnNXz4cI+SMcHUc95553mIjhd3//33+04ZDgM//epXv/J1IT28kA5cTiQMnESnsFi///3v/TMgaujCyn7rW9/yTMMK3nHHHb4uzP9f/vIXP7Aw6IknnvB9YmDATkAYJPydd97pninO7qkrTOjqa55SKbWC00R12mStgbrmnj9rwodJ1VdmlYqF6gqKTn/F/sHk3nPPPZ/4jr9SXgB5VsBA5YVp8eCDDy75DjOjBSm2gu/Ny8r//d///UN9lDFjxnziu9GNj0Rh8FALMBAGwWikHaYxMOAp89NvuOEGBZf9+ljVZuKa9cIlKpRySgdO7+Q7VSoeqmSm5KpsVz4XOFfG+U/x/x73ZbfddvMzA58PCTz11FO9ZCJJhtJvuukm/+JzkMs3h3fc+5Qqeq3qpldBQaJdMSdhYbGPwvg8KdHqKkypFHNTMcipoKyqHPAKm5MqOvcnWZtWR6nBIVcHSFNJbbDGQK3Wv9Y9mxXz9b/A4C0vn6MErWG17nhstt7921N64PZf6tUX5+jEK65TsamPKivmar+919FPTz5Km+3yA3W199a8Fy/QGeeP0t2PznRCV636ii7dcO0pOvbsK7T9tptLyWYN6l+vRJh33k+gnvDp54FV/0kw7NNo5Td7N3//i7QTLZ/GH+6N0vVFeBltd2n1OPM7Tyn3/4Ybr6k1VozrqMtvUiFer+r+i3TQbvupPmhVfkGnBlesomlN1Ro4/Cwlkp3umaI2Xq9Ou+0wwqGrRmWL81UZb1HcudYOTLp/CVr16hIYZ0yEEAz7ZxUAgEHWZemowVdrY1mfLa/DiqnzZa0j2v7S6iiH2HbP56WxXCgtTEkBUNm90T4ZT5ZFKD6tRHlkJTqeQTruBjhe1KtvLdTqQw/X8UfsreNHbKt+8bwa8kktnvKh3njnRc0u9pYy87VZbaCf7H+YVll1JbWkY8oXWnXPLTfro5kNjsC84rFK12oK3adFi7o0xCE3/AX8CIJSoFJQICAH4hobG/0CBjEOYDpBIdAnNprYC69ddtlFq666qke2ADKgN2gRZAhTcBeGDBniI4OgXSA68BpARCAatwFwN2jQII9QoQOITwQRKP/oo496/4p2gOHEcYDygCu+A7ZAwLTLNVwGXAmifltttZXq6+v9YB188MEaOnSoh/Eg7m9/+9seHELnW2+95duiXtAv/SKwBy/w70DBBMHoP0G8559/3tO44447av311/f1G9IGyYPUTZDoI7EvXAyu33ffferXr5/HPyD8p556yoPGhx9+2Afnv/e972mbbbbxIJE+wD/GAtoJzNEfxgSfkbUV6sUr+OY3v+n7jvuFYAI66SduEX2DriAM61UoOoAZm64HHj5f86bO05HH/05NhRUUZlq066D+uvPWs3TWWS9p8zVX0Kg7z9TWB/xOk6a7mVBys6ToZmDBaYOgXs1hlYpMHAQ/VloC3AgXM3P4zkDQaXxBGEpH6OCKK67oI484r/h8dJJrCCCuzmuvvaZ99tnHDxYLCKyIvf3220scYCKQBOJgPAIACme1jIEiyIgfR2QVASHiCuM233xzj/hB5ggXvh3PQy+Di9/54osveqEhCgsY5R3hxEekDtOE0IEgwGgmBO4Tk4V36mc15bDDDvPP4RIxOK2trV7gGFj8ZfpJfQwyg3/xxRf7CO67777rBQEewhfaQJhMM1hQgsGnXhZbEDImCvfynTA4kwI3jeeYgHgfTECEGsFAAN98800f7GAy4uYRbEWgCJ1Tny20EMiEX7iLl156qafZg/JS6KQ8TLrxTyrpXrGwQmGij/rn2jTHCcZTUxrUa9vjXQdqNSTbpl5doWpLWSWLi5WINauYjKuUqVG801UW5hx26vDyVHL/J4Kkn5EwGkbZUiedhJkwASaZdqKjzADeeYbCbOEZ7mUgTMUSbo+uS+A/Uy/3sX6B7wyjmf2848aZGUBwoQdf2UwSwsczH3300RKzDMOYmQyOCQ6zmEG2UDrFojNEw01rmFkiMGImn8i4QQDag1Y0CPciKGgt6iV2cMopp3je0LbRTYFGfud+E2S0K8LONbufVTo0M+0SFeOdYAntEkEnckQghxeaF8GCH7QJLxF+JjyTl+iXue+MC5OD+n7+85/7CU8Mg0nMpAwSCWdXY1M1xJmwV156Xx0tbVp5JeehJTLqHXNMhJFO6AIHsmsrBujeJ8fouMO2Vj6WdYLnvMGwoKLrwI0336d0oUWhcupy5jIb4uWFcNvPWCs0agXmWSF2EC3lwDV6b/n9hhtgMAzvybZ/VjG6os9bG9Fr0XqjGMSu9QS47Vr5b+X1Wonya2l1GW32nfbL+2vfjT/WJoOPpkHAEMSLLrrI34M2YlKQ2wC0+MEPfuA1KkKF8AM7UApobBQAdPKiPtayMflBbnFTGNSkVBQArk1BscYxys2CWLuSQYuKJYjp7YSmpGzezeawU53ZQF0OdKONqmItrvJqp+QqvGZKeg3lVLOrI/mf4ZwtL19iCT5snKu/vZNTc1vBgfMW93I6posAfFLxYKEzXQ4IFp0ZDPLO+0spFSaU7soqnss6COUEL9WldGyKOhVXy+IFOnTvnZ0glZbHn/5HS/DatOmaMLmvrrv2em20/gCN2GkzFdNNzmQ58xHPauwrM/Tk6HHKJVKqSLVql28P15pD6pVwgDwoBmpcOE/3PPKSUtmMVulfqf333M15enh7zr2MfbF4y/Lyn1eCbGyA4umMtttpoC4Yebq23/PnmtbUoVQxpZqKGQ4wX67ESu267a7XdOZhW+qAg3+gDbY+Uh25VZVwdvS043bTkSdto0svv1YDU7VOnzkTGXfANBZ+Ii70z8Q//tOCmpSe6P0qg5pLazN6/5cR2AT8L0sdQa4lp1KhpDNOP0jvj39D82a3KVZbq9BpoFzDptp72xtVrGh2Gqivzrt6tOY2V+mOq0bqzXHT9dhzb+nCW25XIt+mvv36KI7H6LBYiOfkNFx5kPzzduafFbxPG9yvqnxaW19GlHpZ2lna/V9Gu8s6EYJsVYcKc3sriAcqdLqBSTqA7by0rXdYRxsMqNOOW66peYvbdPLZo1RMDdFVt7+s6+8arb51ddp2s430i1NP1etvTdVtd45y2MlhK+Xphoq43h9HaqPphcsSKTeXmGeWpSMWl4mmJn5eTRCNNlM+b6Q9mtRhJUqH8SHa988bJY9GvqP1Wol6cz2tHiS8V/7PRcqt/XINWT6WQanTeXgVU3Xmea26cuRuGjr4Ro2bm9DoMeP1XkenjtiqXum6KoWti3X+7/fUgL6D9MNjztfM1kB3Pf+O2j+arQv/4ITq1bEOUyW7sVOIiesWDAKLBADpLAFDUiWjHSYcUJ7rSo4G8ZJf/vKX3i21jtggR5dyKARKSdEmAs5vuLvkW0SFwtqyz9BGqMCEkUIA8c9//rMPKEZzXsvNRk9LGMSGWA0gpoNrjltOSimfTbCI4LNqQLSe56HHYnHGExsg66P102jExSfQSNiA+9ddd13v+hOEJanHAp5GMwFdgqbWd+J8hAJYFbD7yvlq8a1o/004f/Ob3/gEI3hEoJjUeZss0BQo1qZivkrPPv6mDps2WocfcZgq+vVVZdYxqalCtz97txbWDFZr0Esjz7xH+28zQg+OPMfd01sNuSYtmDVVe373WCdDaa268irI0pJCwJIAHZFvOkT8goAbEXACZLbHgxQtot5sryBaTESWqC+R75qaGr8MgAAQ/SZwh2AStDOmETOBaQQiiY/QUZYWiJCzVILAEWlnKYRlAjrOOwNAwBP6eIalhltvvdUn+pBITdQZOomOE20miMfAMSAkAbHfgAGDmcRi6C80UKCZQCwRZmhm+YTnETBoYWkEGqiP5xFmaGYJhTqIlLOyQK6OTTqeJeWNZQ7ysC2ORYQbwWRJh+R0nod3JFSRGUa6HP0gAPncc8/p3HPP9anDCAPBS+hk5YLgJfewrAV9xJZYMWBsqA/6eNEuY0F7/M7z8LZbQxVrlc00a9DgKl1z9cV6/NnJWjCtTcmqRVqhfl2VqlfUn266W9lYb41+4GylMr31yDPvqbV5kVJBXhWlUGts+k297pjb5aSpWwHzf+jT6FhKgSGsLxGxJapLh5jJZIoxoGgwgmwI11lnneUHnAEjB4cZSMocs5LCGh2ziyULll8ottmECDhRdaLACBabRhg8BIU9QTCatTKSnNBgPI8wkcrH8g8zD41IHiNBOqLcCCwRZDaqwGj6BPPRZAghgs6spo+0iQZmcJkc0IlgkcQO46Gd/nIPbSEsCC9rlGgL1u0YPLQAyzHkHtEea5RRzYXgEr1mOQYtbjmhllNOniaDbTlKJHTBH9b00FCLFy/2SysIFUtLWBF4wf4o+AS/mQSs1bFkw6RkEnMN/hHRt2UtJgX1mul10CmhQqnRqd1G9a3P6LLLL9P09j4qVIaq6bhXL406T8X2Gt1481PK1lSrM6jTaZc84oxnvZMbZwY6nWkI5qi+T62PijvF+XG4IOZnJWtHLLMgwURimZEwgNmHyYFIBph1NQSJzprqtRmIOWFnGwOL2TDzYO/MbtYIWaOjIIwID/VgTizh1hhPtNeWg2iTd35DIMwUUQeLoAgYk4K1L8wqE4JnWWi2aLWZTdq5+uqruxnrPqN5+Q0tS1/MVPI8uaMsGvMcy0sINu3zQguhqVhrQ4ubIJnJRVBZu7TFYvuN9TR2Y6GZoBWhpjChoIV3zK3RZ1tf6DuaCQGlT4yLLRGhqaDTirXFNcbKtskgaJ7XpaDBCUZSsXydwkJSBx+6r+bnM+rVN6MNBw3U+Ilj9Kf77lBjtl4p12j/ulpddeR2zrQV1ekYf939L2na7IyToYQD5K4xsRss5dfySL2EUBjQu3dvbxZYnLVsAhhsi8DMQr8W5IhivcySjDFt1kEGgwFjCSC6l4jnSbGEyXxnKw2/oQFY86Pzps1sfYu6bDGW+qBjhRVW8ExFOyGQCDq/o/mY/QgBmox1LzND0GtrcZgiW5LgNwaPa5b9TXs8h6ai/9BICikDiwbjM3Wxao9QgQlpK4qzMFOYXJKuKSbs8Jd0WEwwJpq2WXOzBXC0NdoM7cfSCtYCPtsEJ/WWhff+/ft7DAo90M5EoC/QDg3QaNsOsSpMPJ5DE3djqHx/N/RTnUC0OOaVdO+dz2pGY1KlTIvaim72hm4W5FZWZSapbDyrhZ2BTrhytLvfdTJVUEchqyTAruS0ihOmRNgtUOgPCGWmWHp+FOQZOEZzYeoYOBgLsQyaAUZS7bmPzkVBrJkafkNFswZlZgGNRufAQ9TJc1YfK+585znMCddZCPUr5a5ezBzPwEijE3MdXd3HTJT3AxpsAdXANbObhGyjB9PAdfoE/bQH5qFPDBBmnHqpH8E0Oo12PrOyb7QYDVEnBUE0B4J3aKItsI/fI+raBMuiYaGLHGrwKtaELAK0KROftjBptpCPFuI6QsvEY98akwyNiLCaNXH6rsM1WKd8slXtxbja8VicRsgV8CLiPlUuSDg3vtiuxZlKZbJFDaz6QDmHqUrKqCaRk0NcCmLNTpxSao/X+XTgbKzLyVW3SShf2C0vNlCmjpe2aBr9zcyNPRttw+op/xy9P+olRhese/pOibrk5WVp/TNajYaoix1d3LbnozSVL/5GQxDR+z4rREKbRgefcVDIRcNBIL0GYQDToZXRmmRSMAnATQghWggTCpYlrQVYgRZHuBB8nsHUklqEJQhCJygZN/j11Um98PSrGtyvQtVO6xRLDk94LMRWhrizjV169fk3lamo1K9//nMV4mmf8+SUvSZPb9XYl55y4tWseDGvBB0Eoy37Yv/y8i8qCB8OCSYKAcA5Yqc8niKCRZ4Tmpu0Hz5zHYzH3iBMMLjMMhsA/jhOeKSAdDRXsPP2w7W5G/wj99xCNfG8thuxoTqcZmLDAnYLHAg2SiWc9mrLO5NUCRZXPMGP5Cx1SlvWqnPfDZ157FQvd1+cxLvl63j/lgXNh+dmONJ2KxuUwPPjHUxl+9ktHsY+eDO11GNbmAivWNwqyLU0h3H3Y1tnh2LJjLpyzrYnnQiV8konnR0G1YcZJyQOnBEWQPsknLA5Exc6geoWODBThU/U83GoWOhfzpoqhPAYSXxFZxLjPjWmGPLJWVuh4TqUiOWUCNx9RQfug7RaOjqVSAY+D6vS0UD2AlF3sfMmnnL1xLzy+1/dyby8LC//KyVoqSrosSee0f0PjdM3RhygSRM/kFc5CWfNwlbFk13KxzqUqg6ch1ijeN7h7XSNWheX1N7sFE6pVsV8jbryoc8wj6Xy6tJi97ld+bjTjs5xDMJm5wi2qrYioRWc2c44RVgoxJ2TUdTi1jZ15HPOgsadosqqq0gEP6XKqrTeeOV5nXjkIdp286HKJrqdnIRTdgnZispyDbW8LC//zSUoKK1EagW1dlSqpSurR5581k37Dh343V20z967OgVTqadefkNjxr+sma9MUKyTXII25yyG2nLERtpl5x3Vr26AnnnhHd18y+OaMq1VuUJvh4yy2mOzWh184E5af7PB+uvYCbrnkQf10ZzZKhYcpHOQvVcyrV132EYHbr+Vc5wTuvmhCbp/1J0O9mf0nT2/5fzIKudBZpQPE84PJbrT1Y3O/jEhaHlZXpaX/8ISpPMVSud7OYRSq3y+RQNXSeqUk/bWTsM31PTpTTp35DUa/dYstVdVqpRLKlFkUafWIaK8Jrw5RQ+PmqNNNl1PmeqkcwsdtskUnKs23ymTpFo65zpktLnixbhWCCo1IBiohsVFLVhUUENXUfMSSU2eNEY33PKK+g/op06HzopE7h0UKzillMxU+pUc1nDCsOQXCrtD06HKsxajOSpfZjbbv6osS2rqF93y+79QPm8667+y9ESblS9K479Tvz/POQmfVYJMosO5aW0KS6ESQaC11l5Fm248SMlYo+bOmKrJ70xxv/VTIRdwzJ0SFXO09uprqr6qWpXO3YrnWhV2zVS7c9dW7FWhWR80KhX2VS5frZcnBnrhuAdVmb1F/etDDVwx0PAt67XZsE3Ut+8A5YqBFi7u0DsT39fLY15X49zFCjs7nXvXxynCVsXyrY6OgmIfp8IQKCVyj8KykGk046CcGdHswi+ax00pP/egvL0vUqyer1KIl6Usrf1y/n6VtHwaD8ppWdZzL3oqX1UfPov+ZX3m0/YmfFFa/pXK67No/tT9CUWniMJEi8AuYSyjdydM14SJ09V76BCtNng9rbvuJprx7lyJpdJSTIXOjKZOmqM5sY8U71ikVVes0sknHabtthuhseMn68yRl2n6nIVKV8RUUydV11SrqT2t9+c1uZer5PUu3fLwm0rmOlQdb1Z10KQ9dtpQt593psLaOj382It+QV6FNgUJp5wcUov7bJiPFUwY/3h5UR5VWUaLpXNbqo6lN33etPBPK5YwQelpvfaLFMugLU8Dtzaih8l8WW0urZSn1kfpsPevajNSlA/RNpdGS0/3RHloqW1fR4nSYFlWPY1bT4fZUD6N7mgfyw/X+arlY1lKNAnHvvc0lp+1vSSI5zNKlqqUiofqiE3VjNkt+vFxT+vAvSZpv12300WXHaYD3p2hMeMnaeKUGVo4K1QuGTpUVKf1V95ee2yxvjZav6/SiS61OreuLTlYXcU5yjrFM2y9QTp4r901fMMhmvTOVD397JuaMHm65jQSRA9V27u/1lttmLYZsZnq6ntr7Hsz9fLz47RgfrPSmUCxQm+VipnuuBOHA8U6nWZod51labqkuXPm+GMeSHIlJYxkXJJUydwhE5qlTbJ/yB4i/Y6MoKjSsu9RQY6eaWLZSvY7ScYkfZCaRsIy6/Tlk8CeKUdy1GfHXdpWALvP8iI5vIfkZ3JESRghg5v7OQuF4zTItiJBl7Q6y5CyuqKZZtEtBdY/U660aVlWJkDRLC/rN+8kDJNvQHIKySzkqZpQUYdtkYimOVp/aS/aRnSbBXXbAbI8a0dseIF010nHpP+MIUvOZMtxH+mW5OySlcU4s9WDDDnqtL5CF3WwI4GDkMijIBmaPnCdtkgk4j7LpLOMM+ghyYf+U0xOLDPOCu3ZcSbR7TXlmWtcI1GIhGrkhYw/8jZo3zL/oIncYVJOSfhGBkgNJfXRxhDeWB9tjCxdk8RunoMPpIKSyWYKir5yLznOpLmSeA7PSDw3mYUPVr+NbXSPmslXVDbKE8vKtxcZfdTBAVZkF5LsRFIUifAk0sM75i7JUZbJZ3y1Nry8plNpd8E1kHCNkk4QVjtlVaeJ42fp0onXK5V0Ap2sVAGXzqGZNXvH1eCutZSyev3t9/Xcc2+opbNBhWqpsbiiivl+CrJrufoWatb8gq668QHdlq1QhnTORKisQ1aD6upUCEr+bzJMbpiimU9M09UPFrRwdqBJk2epvr6XOktJtcOYIBnZQmOoojvORBoo2V6kHZK0zsDDbNv6wcBxH4OGcPOd+/gOs8gYI+8XISZfg7RJMsrIE4axTFD2QZEvS9olgwkTOYaEJCHuI8+W83TZHsMJZdRHHjNKEcFjRwPPMGFQPGSgIXwkF1Go0/JrUXwkFvE8LxKPUEacq8OOCfpC/xhAtrGw5YXcYLb60C7CzY4GziJCCHihvMn9ZY8VE4QcXvKaqZ824QH9QIAQcIQJGjikGT4iZNTHlhmeJSGd1FWS3RF23pkA8IiUT9JsyQdGoZEgT14MOcjsRCHvhVRceIXSYWcGSVkkUJVnDkIb/WRsTFGzNYdr1E1yPMYChU4uNPnP8Ap6SDslmYsELQwThgVlSlsoLfK/2QmCgcGIsTuE++APfGR8SadljDAIGDnqY9cL/Cc9ldxonmWMyC+nnzaWUdfTDKHt14M2m/xMRjYM0H/a5HmUip1hhYKGr9xLsj5KBVlj/KCBrWQkoJlBYtIjs9AJ7eR6s6uHDEj6iOGGd2y8IDWYBDhymKAD3pHkhsxy4DbzBJmHd9SPvCAPtEk2JrxH0dF/5gy7XaiXFF42GZAvz8YPtoSx1w45JdecAp0UlDfGxvYEshvmkEMO8fwwRR/kcpVKBv3U2TFJyZTrbHKeu6FKvxh5oDZyAnTvvY/r4isf1uwWhyTUpUx8phpTTtnEshrQbzWdc+7x2nzzQWpoWqjzr7xPjzw4RtUV1dpkcEo3XHywBjhGzWtO6/tHnaFx78+Xsr1ViLmG3fgVOpqcm+csTUer00MZNSRWViJTqw45K6ak4sm0Pz4oXKKYQp8dipuXy3UtEWKS+RFAXigBhIVdNLbjBWuMBYEhDNJ+++3nmRa1SExIlAhCx8Ay8DCS/GoGDytslgUkw/MoRDYaMOj8zREOVWPSYTGx8NTFgNnhX7SNALH9CoVgAsxvWFImCYn+KDBDAkzKSy65xL9AiQwmWZP0G6RBn8x1sIPJuIag204eBId9kCgUDiqfMGGC7xdCQXYmk5V+sbOGPYwoJMvVhzYmI1vMmEz0EZowDExw+Eo/2UbFM/DRUCd941AzFBvCDU/hC8oKpWObOqKHtkU30/LOhhAmk9WJMrVD5qAXRcLzCDd8Z0xoC/6R2mwHwMMPO+ANZYvhgX/slAKh8h1lh4IBpTFBmcDUwfMoVGjHMNAnO10RXqNIyHxFLoxnhiQMOUMvhtT+VlkUecD7KM+gAaWPAWKvI0oa48p4mlyQgo3s8Rnjg8JASfOd+jG4KAWUMtdRBPQdRYJ80SbjwHhCO6cUopzoN2OLckLR2R/woW/MI57BuEMnz9IeRhHeMN+QK/jGZ/rNHIKHyKClz9M/kBRzCh4iXxhT9nTQ1+gfRQpC54oV4wuUSHForxPKkKMIkooVE14hVFc5VJVsVylwWj1Ro/auwQoSbXIAXXUOyXw07hWl1+mtunxO2ULKDcgKyoVZNfr9Cv3cKPRR2JlXn8xK6hfkFLp6k/5Ezrjagl6uxQo1O7pj6V7KFRy0zsdVFc84BEZnGEDW8fIfH9f5dxxFxxBU9jkyOYCKWDusAAIEA4DKWFrbhmfCYlCcwvNMKp5h1xCDggZHQBAKJkEU6lquP4LCBC13oZjgbAJBEdA+VgRojWCzJxS6EZQlFuJjwaSAYFCO3MORlbZTCQSCBWQisOEXVGZ0cC99oB76bDDZ6jVrbIfhlR8QaErXlIN9NxeMfuIegTzoLwaAz0x8hJ9+gvwQLCwkY4AyRMhBbyhTlBF7Ug1dRN0i6Im63ub6GpKKHgNh42CKrTxYHt0MFUUx3AuqY5KgwDAUZsWtDp41tEOBb1YH+1lBC7QPcmaMUXhMahANSir691bKlay1Q5sgeaPVjIDxOnrqAHzFHeR+lCObkmgHxEOMFnln0xIoEb6iIOxvOUEjrjHuOUrX2uEdulEYFOMzY2BygxECVbPPGC8CxWT7UHgeA2HbM6N/T8bcPhuv6BEf5kZbiMO2szLvUHYgfOQdQ49XRBtLjG4YjwFIaE6xMOVf8VLav0pOWaw8cHUH+fdXA4cf5BPKOiQ1P9akhY1Namho0j3PTNElt56sxZ1u0NNrqZQY7PyWvFNoKa988tSZTmidjYcrU9fPKR465ZBakFCzcxkbc2m9PflDLW5sU7KQ9XshEMeEP9+cpMyCf/97TiZ/5Mn5pq7DdJKJb740iACLyITCauCuADcZAASTOI65GTwDoxgA0AlQmk1Ahrqw+lgliz9wPwrCJhZtMGBYRM7NZRCYpNBhf8UNxYF1xm1gEOxkAbPyNgimGEB2bEllwNkojsLhM8gJ99HOUuZelCkWCLSDEEMXG6DsyFr6yH3E5UAWhoRoH0WCO8s1aLbdgqZQLT6BZUXBmwCjrPkNnmOl6Qf04H7SDryGhyhkUCJnHpuwcuwJiIDvpiyjwfZosJd62fZQjiyi8TZDV1h8Ptt+bFOwuL242dYev+G6UB8TzNxHJoahPlOWoAYmJPXYES2gKtxb6x8TGWUBkqZE45EWczS+gvIMOZiiiJ5/Q58wiigY6y9jhbFCwSALtAvPUT6gGJvoGC9kwcacccMQ0jZ8gpcYbQwbbiS0I1cYEcYMV4x6LczAJjnbFcpcQI75zLG8GG9T/mwbZq4ZrbZ1Gw/BlB19BxVBn/GI7ci45BgJM1BszQZBWV3REoS5GoX5vg7ZVLiJ7xRBol1hYqF7NTvFVdDMGbN1261/0dyOGpWKoSqKrVqUzKmExnTumJo7HOd7udarqc6ZisVKFdtUXZCqHaoKOEm9kNajo9/Wex+2OnWT9KfrF7taHDIjmMbB6E6AigX/NzCJhzst57e5hGG+O//Jpz6FXkmV/Jh2nxdTjFheGIwrYEeYWGAPBcRAch+xp6iFtV2XplwYSBMaCwJHd5HaFmKzzIYIqNespAk0FhBBjwaHEQSzPuWrdHboAnXSJvQwAaPBbgtO0wbvoBgEO1rsr8EaaqQuyw2z+g1RlK9E0qZNfngGvRYr4br9uaVoUNSUCAW6iH1YfdHgKvcYb8pz1ax/pmAo8NRcJbO+xieum5tE/6IBeRs7eFPeDi6MoWC7H6Vv42E84zfru51xzmfcchYKojJg8hEN0puc2LkJxuso4isPNqNQGMtogN6QIwaKtqP8sXGx+qKBZnjEWNpvtMuRQSgC5giGknowGqAk4oagSwuZgIjpJ1vNeSc2B2rE8IKIOeuArfhcp27cRzvcAtDAdeKRKEX6SL9QaKA8+IVs4Z2wtR2DiDFAOeOSYnQ5Q2FJkByvKpefpyA1W/H8mt0nzTkHLQxr1ZUL1FVwiCZdUPv8mUq4ydWadoyJ8ReqHKPaG71OijmtEeadIMVn+aMQYyVOC15bi+LV/q+CVlSH+tGBw9XQ1O6Qk7Nepe7ky240VPTKp+jqeG/KfI154a/KxNjB7JRTySEDp6Q6w0rFE67+MMEfYfPnpBNhT/RwDrktW37WVu9oKd/OHX2mfNt5T8vb5cunBuGjpXwptad6ejrRrnzJ2IR6aVv0o/SWb7Xvaat++TPWZk9ntffUl/Ll7Ohv0ZXBaN3lvIi2sbSt9VEay3lX3h+rr6el9vK2l3ZefNQILe23nuotv2dppxSW89X43ZN8Lo3f0fp6OoeeYq6qxfls9Q8FzsZd3HVcQRQgSBKlBGrDVUc5cQ3ky9lmIGqUGTEv0DpxKhZ9qJu4LzE9FmqsHZQOnglega2aRmOO0IoR5jnimCAwgvIYpyVHQvE3fgbU12hQ/17qlcrpkH12ViYo6cWnH9cbzh3r6uzSvjsPVy5Z67f2xuPENGLGIf9iQzGrfcWCY4b7nE7CrJLuGXVft8UusEqYdG6jI9zdk46DhrCuWPu83+leci7m0FV6a539d1Qm5SB7vENDV19J/XpVKO1gVUAiKX/MAQcQS9TDObDLy/KyvHyymEIjXsUiEEoBN8oUJKuKxHBZXEGpoHDsD8xTQEzEvkBBKBYUlS0U8R13jRADCBAlCfpBwYDIWA22k6po19ArXgRhFepFMUIbYQKUGIUYLTR6BFVdEWiLYUM1bPMNnasV42/G+xW2AA3H6eK4Sw4xFWL+2IK/Z3Cr/IP8vUE85tFQEO8+/MfrEn+Pg6xxXBCfOfBxQUt2n3QAoiqW0u45v5FlSV1hqeDPb4lRCbuR4x8TsVw5LS/LyzIVlBTutcV3oquHFl8kJhVNco6GSCjmlrLSHM1rQ+FwrTyJGbc2egyz1WFuLvVGUSr0RfP4rPw/jwStEBv7OEAAAAAASUVORK5CYII=";
      let totalPagesExp = "{total_pages_count_string}";

      doc.autoTable({
        margin: { top: 113, left: 10 },
        theme: "plain",
        head: [["No", "Part#", "Mfr", "Description", "Qty", "Unit Price", "Line Total"]],
        body: [
          ...this.setNewArray(this.saleDownPayment.products),
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: "Tot.Ex.PPn :",
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.total),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: `Total ${this.saleDownPayment.percentageDownPayment}%`,
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.totalAmountAfterInvoice),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: `PPN ${this.saleDownPayment.percentagePpn}%`,
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.taxAmount),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          // [
          //   {
          //     colSpan: 5,
          //     content: "",
          //     styles: { valign: "middle", halign: "center", lineWidth: 0 },
          //   },
          //   "Art 23 Income Tax (WHT)",
          //   "0",
          // ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: "Total",
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.totalAmountAfterTax),
              styles: { valign: "middle", halign: "right" },
            },
          ],
        ],
        styles: {
          valign: "middle",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
          fontSize: 7,
          overflow: "linebreak",
          overflowColums: "linebreak",
        },
        headStyles: {
          valign: "middle",
          halign: "center", //'center' or 'right',
          fillColor: "#DDDDDD",
        },
        columnStyles: {
          0: { cellWidth: 8 },
          1: { cellWidth: 30 },
          2: { cellWidth: 25 },
          3: { cellWidth: 62 },
          4: { cellWidth: 12 },
          5: { cellWidth: 25 },
          6: { cellWidth: 25 },
          // etc
        },
        didParseCell: function(data) {
          if (data.section === "body" && data.column.index === 5 && data.row.raw.length === 3) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = "#DDDDDD";
          }
        },
        didDrawPage: () => {
          const item = this.saleDownPayment;
          let str = doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }

          doc.addImage(imgData, "JPEG", 10, 10, 90, 20);

          doc.setFont("Times");
          doc.setFontSize(10);
          doc.text("INTERCON PLAZA BLOK D. 11", 10, 35);
          doc.text("JL. MERUYA ILIR, SRENGSENG-KEMBANGAN", 10, 40);
          doc.text("Phone   (62-21)7587-9949/51", 10, 45);
          doc.text("Fax     (62-21)7587-9952", 10, 50);

          doc.setFont("Times", "bold");
          doc.setFontSize(15);
          doc.text("INVOICE", 140, 23);
          doc.setFont("Times", "normal");
          doc.setFontSize(10);

          doc.autoTable({
            startY: 25,
            theme: "plain",
            tableWidth: 90,
            margin: { left: 105 },
            body: [
              ["Invoice No.", item.invoiceNumber],
              ["Invoice Date", `${moment(item.invoiceDate).format("DD-MMMM-yyyy")}`],
              ["Cust. PO No.", item.purchaseOrderNumber],
              ["Term", `${item.invoiceDuration} DAYS`],
              ["Due Date", `${moment(item.invoiceDueDate).format("DD-MMMM-yyyy")}`],
              ["Page No.", str],
            ],
            styles: {
              valign: "middle",
              tableWidth: "auto",
              lineWidth: 0.1,
              halign: "left",
              lineColor: "black",
              fontSize: 8,
            },
            didParseCell: function(data) {
              if (data.section === "body" && data.column.index === 0) {
                data.cell.styles.fontStyle = "bold";
                data.cell.styles.fillColor = "#DDDDDD";
              }
            },
          });

          const tableY = doc.lastAutoTable.finalY + 3;
          doc.rect(10, tableY, 90, 40);
          doc.rect(105, tableY, 90, 40);

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("CUSTOMER NAME", 12, tableY + 5);
          doc.setFontSize(10);
          doc.text(item.customerName, 12, tableY + 10);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          let splitTitle = doc.splitTextToSize(item.customerAddress, 70);
          let size = doc.getTextDimensions(splitTitle);
          doc.text(splitTitle, 12, tableY + 15);
          doc.text(`Phone    ${item.phone}`, 12, tableY + 15 + Math.ceil(size.h));
          doc.text(`fax      ${item.fax}`, 62, tableY + 15 + Math.ceil(size.h));
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(`Contact Name      ${this.contactName(item.billToContact)}`, 12, tableY + 35);

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("BILL TO", 107, tableY + 5);
          doc.setFontSize(10);
          doc.text(item.customerName, 107, tableY + 10);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          doc.text(splitTitle, 107, tableY + 15);
          doc.text(`Phone    ${item.phone}`, 107, tableY + 15 + Math.ceil(size.h));
          doc.text(`fax      ${item.fax}`, 157, tableY + 15 + Math.ceil(size.h));
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(`Contact Name      ${this.contactName(item.billToContact)}`, 107, tableY + 35);
        },
      });

      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }

      const y = doc.lastAutoTable.finalY + 10;

      doc.setFont("Times", "bold");
      doc.setFontSize(10);
      doc.text("PREPARED BY :", 30, y);
      doc.setFontSize(8);
      doc.text(this.userDetail.name, 30, y + 25);

      doc.setFont("Times", "normal");
      doc.setFontSize(9);
      doc.text("Note :", 140, y);
      doc.text(
        "Please quote our invoice numbers when making payment. if multiple invoices are included in one payment, please let all invoices being paid",
        140,
        y + 5,
        { maxWidth: 60 }
      );

      this.url = doc.output("datauristring");
    },
  },
  created() {
    this.preview();
  },
};
</script>

<style></style>
